import PropTypes from 'prop-types';

export const columns = [
  { id: 'TO_DO', title: 'A Fazer', color: '#2196f3' },
  { id: 'IN_PROGRESS', title: 'Em Andamento', color: '#ff9800' },
  { id: 'DONE', title: 'Concluída', color: '#4caf50' },
];

// dayjs weekday numbers: 0 = Sunday ... 6 = Saturday
export const weekdays = [
  { id: 1, label: 'Seg' },
  { id: 2, label: 'Ter' },
  { id: 3, label: 'Qua' },
  { id: 4, label: 'Qui' },
  { id: 5, label: 'Sex' },
  { id: 6, label: 'Sáb' },
];

export const formatWeekdays = (weekdayIds) => {
  if (weekdayIds.length === weekdays.length) return 'Seg a Sáb';
  return weekdays
    .filter((weekday) => weekdayIds.includes(weekday.id))
    .map((weekday) => weekday.label)
    .join(', ');
};

export const taskPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  executionDate: PropTypes.object,
  time: PropTypes.object,
  recurringTaskId: PropTypes.number,
  sequence: PropTypes.number,
  columnId: PropTypes.string.isRequired,
  notes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
    }),
  ),
});

export const recurringTaskPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  weekdays: PropTypes.arrayOf(PropTypes.number).isRequired,
  time: PropTypes.object,
});
